import SampleData from "./SampleData";

export default SampleData;